module.exports = __webpack_public_path__ + "img/transparent-nav-right-nissan.9d073630.png";